import * as React from 'react'
// libs
import { AttachmentPrimitive, useAuiState } from '@assistant-ui/react'
// icons
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined'
// views
import { FileChip, FileChipName, FileChipRemove } from './views'

const AttachmentChip: React.FC = () => {
  const name = useAuiState((s: any) => s.attachment.name)

  return (
    <AttachmentPrimitive.Root>
      <FileChip>
        <InsertDriveFileOutlinedIcon sx={{ fontSize: 14, flexShrink: 0, opacity: 0.6 }} />
        <FileChipName title={name}>{name}</FileChipName>
        <AttachmentPrimitive.Remove asChild>
          <FileChipRemove type='button'>✕</FileChipRemove>
        </AttachmentPrimitive.Remove>
      </FileChip>
    </AttachmentPrimitive.Root>
  )
}

export default AttachmentChip
